import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, setOpacity, withTheme } from '@glu/theming';
import store from 'core/store';

const isLegacy = () => {
  const state = store.getState();
  const { hasTheme } = state.ui;
  return !hasTheme;
};
const withStyles = (styles) => (Component) => {
  const useStyles = createUseStyles(styles);
  const StyledComponent = (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const classes = isLegacy() ? {} : useStyles(props);
    return <Component {...props} classes={classes} />;
  };
  StyledComponent.propTypes = {
    ...Component.propTypes,
    classes: PropTypes.objectOf(PropTypes.string),
  };
  StyledComponent.defaultProps = {
    ...Component.defaultProps,
    classes: undefined,
  };
  StyledComponent.displayName = `WithStyles(${
    Component.displayName || Component.name || 'Component'
  })`;
  return typeof styles === 'function' ? withTheme(StyledComponent) : StyledComponent;
};
export { isLegacy, withStyles, setOpacity };
